module.exports = Promise;


//////////////////
// WEBPACK FOOTER
// external "Promise"
// module id = 9
// module chunks = 1